import React from "react";

import Svg, { Path, Circle } from "components/Svg";

const Plus = props => (
	<Svg
		width={15 * props.scale}
		height={15 * props.scale}
		viewBox="0 0 103 103"
		fill="none"
	>
		<Circle cx="51.5" cy="51.5" r="47.5" stroke="white" stroke-width="8"/>
		<Path d="M51 27V75" stroke="white" stroke-width="9" stroke-linecap="round" stroke-linejoin="round"/>
		<Path d="M27 51H75" stroke="white" stroke-width="9" stroke-linecap="round" stroke-linejoin="round"/>
	</Svg>
);

export default Plus;



// WEBPACK FOOTER //
// ./src/components/svgs/Plus/index.js